const WORDS = ["Rio de Janeiro", "Balneario Camboriú", "Bombas y Bombiñas", "Florianópolis", "Sao Paulo", "Guarujá", "Angra dos Reis", "Cabo Frio", "Guaratuba", "Caiobá", "Curitiba", "Natal", "Maceió", "Brasilia", "Salvador", "Recife"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 text-5xl sm:text-7xl ${i % 2 ? "font-serif-i text-sol" : "font-display font-extrabold tracking-tight text-arena"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0"><path d="M12 2 22 12 12 22 2 12Z" fill="#FFC93C" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Destinos" className="marquee-wrap relative overflow-hidden border-y border-sol/20 bg-selva py-8 sm:py-10">
    <div className="marquee-track flex">
      <Row /><Row />
    </div>
  </section>
);
